import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import handoffConfig_csmAiHubQuery from '@atlassian/jira-relay/src/__generated__/handoffConfig_csmAiHubQuery.graphql';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const helpCenterSettingsAgentStudioHandoffEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-help-center-settings-agent-studio-handoff-config" */ './index'
			),
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
		queries: {
			page: {
				parameters: handoffConfig_csmAiHubQuery,
				variables: {
					helpCenterAri: `ari:cloud:help::help-center/${tenantContext.activationId}/${context.match.params.helpCenterId}`,
				},
			},
		},
	}),
});
